import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

const Input = ({ id, name, type, value, onChange, placeholder, maxLength, disabled }) => (
  <styles.Input
    id={id}
    name={name}
    type={type}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    maxLength={maxLength}
    disabled={disabled}
  />
);

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  type: 'text',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js